export default "__VITE_ASSET__BbQ1VvJ$__"